<template>
  <div>
    <el-form-item :label="title + '类型'" v-show="!receiveTypeAll">
      <el-radio-group v-model="data.present_type">
        <slot name="presentType"></slot>
        <el-radio v-for="option in presentTypeOptions" :label="option.id">{{ option.name }}</el-radio>
        <div class="m-b-10"></div>
      </el-radio-group>
    </el-form-item>
    <el-form-item :label="title + '配置'" prop="receive_user" v-show="receiveTypePerson || receiveTypeAll">
      <div v-show="!receiveTypeAll">
        <el-checkbox :true-label="1" :false-label="0" v-model="data.receive_user.founder_status">发起人</el-checkbox>
        <el-checkbox :true-label="1" :false-label="0" v-model="data.receive_user.founder_higher_status">发起人上级</el-checkbox>
        <el-checkbox :true-label="1" :false-label="0" v-model="data.receive_user.back_higher_status" style="margin-left:0">上一步处理人上级</el-checkbox>
        <el-checkbox :true-label="1" :false-label="0" v-model="data.receive_user.free_status">自定义配置</el-checkbox>
      </div>
      <el-select  filterable clearable class="w-230" v-model="data.user_ids" multiple :placeholder="'请选择自定义' + title" v-show="typePersonSelf || receiveTypeAll">
        <el-option v-for="item in users" :label="item.realname" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="接收分组" v-show="receiveTypeGroup || receiveTypeAll">
      <el-select  filterable clearable class="w-230" v-model="data.group_ids" multiple placeholder="请选择接收分组">
        <el-option v-for="item in groups" :label="item.title" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="接收部门配置" prop="struct_ids" v-show="receiveTypeStruct || receiveTypeAll">
      <el-select  filterable clearable class="w-230" v-model="data.struct_ids" multiple placeholder="请选择接收部门">
        <el-option v-for="item in structs" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item 
      :label="title + '配置'" prop="" v-show="receiveTypeRelation || receiveTypeAll">
      <span>本表字段：</span>
      <el-select  filterable clearable 
        class="w-230 m-b-5" v-model="data.related_field_config.field_id" 
        placeholder="请选择本表字段" 
        @change="relationChange(data.related_field_config.field_id)">
        <el-option v-for="item in inputList"  :label="item.default.name + '(' + item.default.title + ')'" :value="item.default.field_id"></el-option>
      </el-select>
      <br/>
      <div v-show="isRealtionForigen">
        <span>关联外键字段：</span>
        <el-select  filterable clearable class="w-230" v-model="data.related_field_config.related_field_id" placeholder="请选择外键关联字段">
          <el-option v-for="item in relationForignList"  :label="item.title" :value="item.field_id"></el-option>
        </el-select>
      </div>
    </el-form-item> 
    <slot></slot>
  </div>
</template>

<script>
  import http from 'assets/js/http'
  import modelConfig from 'config/modelConfig'
  import flowConfig from 'config/flowConfig'
  export default {
    props: {
      title: {
        type: String,
        default() {
          return ''
        }
      },
      data: {
        type: Object,
        default() {
          return {
            receive_user: { // 接收人配置
              back_higher_status: 0, // 上一级处理人上级
              founder_higher_status: 0, // 发起人上级
              founder_status: 0,      // 发起人
              free_status: 0,         // 自定义配置
              related_field_status: 0 // 关联字段配置
            },
            related_field_config: {
              field_id: '',
              related_field_id: ''
            },
            present_type: 0,
            user_ids: [],   // 选中用户id
            groups_ids: [], // 选中用户组id
            struct_ids: []  // 选中的部门id
          }
        }
      },
      users: {
        type: Array,
        default() {
          return []
        }
      },
      groups: {
        type: Array,
        default() {
          return []
        }
      },
      structs: {
        type: Array,
        default() {
          return []
        }
      },
      inputList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        isRealtionForigen: false,
        relationForignList: [],
        presentTypeOptions: [
          { id: 10, name: '固定接收人' },
          { id: 20, name: '选择接收部门' },
          { id: 40, name: '选择接收分组' },
          { id: 60, name: '选择关联字段' }
        ]
      }
    },
    methods: {
      relationChange(id) { // 本表字段选择
        this.isRealtionForigen = false
        if (!id) {
          return
        }
        _(this.inputList).forEach((item) => {
          if (item.default.field_id === id && item.default.type === this.TYPE_FOREIGNKEY) {
            this.isRealtionForigen = true
            return false
          }
        })
        if (this.isRealtionForigen) {
          // 请求外键关联的表字段
          this.relationForignList = []
          this.apiGet(`cms/deals/foreign_fields/${id}`).then((res) => {
            if (res.code === 200) {
              this.relationForignList = res.data
            }
          })
        }
      }
    },
    computed: {
      receiveTypePerson() { // 接收类型为接收人
        return this.data.present_type == this.RECEIVE_PERSON
      },
      receiveTypeStruct() { // 接收类型为接收部门
        return this.data.present_type == this.RECEIVE_STRUCT
      },
      receiveTypeRelation() { // 接收类型为关联字段
        if (this.data.related_field_config.field_id) {
          this.relationChange(this.data.related_field_config.field_id)
        }
        return this.data.present_type == this.RECEIVE_RELATION
      },
      receiveTypeGroup() { // 接受类型为接收分组
        return this.data.present_type == this.RECEIVE_GROUP
      },
      receiveTypePost() { // 接收类型为接收岗位
        return this.data.present_type == this.RECEIVE_POST
      },
      receiveTypeAll() {  // 接收类型为全部
        return this.data.present_type == this.RECEIVE_ALL
      },
      typePersonSelf() {  // 自定义接收人
        return this.data.receive_user.free_status == 1
      }
    },
    mixins: [http, flowConfig, modelConfig]
  }
</script>


// WEBPACK FOOTER //
// receiverConfig.vue?00f7fee2